import React from 'react';
import './scroll.css';
import Arrow from '../../svg/Arrow'

function ScrollTop() {

    //Javascript function scrolling up
    //When the user scrolls down 20px from top of the document,butoon will appear
    
    window.onscroll = function(){ scrollFunction()};
    
    function scrollFunction(){
        var mybutton= document.getElementById("mybtn");
      if(document.body.scrollTop>20 || document.documentElement.scrollTop>20){
        mybutton.style.display = "block";
      }
      else{
        mybutton.style.display="none";
      }
    }

    //When the user click the button,scroll to the top of document

    function topfunction(){
      document.body.scrollTop=0;    //for Safari
      document.documentElement.scrollTop=0;    //for chrome,firefox,and other   
    }



    return (
        <div className="scrolltop float-right">
          <div id="mybtn" onClick={topfunction} >
             <Arrow className="i"/>
          </div>
        </div>
    )
}

export default ScrollTop
